import { hbs } from 'ember-cli-htmlbars';
import { workflowComponent } from '@banking/ui/services/reporter';
import { scrollAction, updateSelectedTypeAction, updateSelectedCardAction, hasActivities, hasNeverHadActivities, showPreviousBalance, showTransfersFooter, startingBalance, updateDateRangeAction, updateDateMenuSelectionAction, isExportDisabled } from '@banking/ui/workflows/unified-activity/unified-activity';
export const template = hbs`
  <Banking::Activity::Page
    @loading={{this.loading}}
    @loadingNextPage={{this.loadingNextPage}}
    @startAt={{this.startAt}}
    @endAt={{this.endAt}}
    @startingBalance={{this.startingBalance}}
    @selectedTypeCategory={{this.selectedTypeCategory}}
    @selectedCards={{this.selectedCards}}
    @selectedDateCategory={{this.selectedDateCategory}}
    @hasError={{this.hasError}}
    @exportLink={{this.exportLink}}
    @activityList={{this.activityList}}
    @hasNeverHadActivities={{this.hasNeverHadActivities}}
    @hasActivities={{this.hasActivities}}
    @isExportDisabled={{this.isExportDisabled}}
    @showPreviousBalance={{this.showPreviousBalance}}
    @showTransfersFooter={{this.showTransfersFooter}}
    @typeCategories={{this.typeCategories}}
    @cardCategories={{this.cardCategories}}
    @showFilters={{this.showFilters}}
    @goToStatements={{this.goToStatements}}
    @goToActivityShow={{this.goToActivityShow}}
    @emitTypeFilterChangedAction={{this.emitTypeFilterChangedAction}}
    @emitCardFilterChangedAction={{this.emitCardFilterChangedAction}}
    @onScrollToBottom={{this.onScrollToBottom}}
    @updateDateRange={{this.updateDateRange}}
    @updateDateMenuSelection={{this.updateDateMenuSelection}}
  />`;
export const mapStateToProps = (state, ownArgs) => {
  const {
    activityList,
    config,
    loading,
    loadingNextPage,
    query,
    hasError,
    exportLink
  } = state;
  const {
    startAt,
    endAt,
    selectedTypeCategory,
    selectedCards,
    selectedDateCategory
  } = query;
  const {
    typeCategories,
    cardCategories
  } = config;
  return {
    loading,
    loadingNextPage,
    startAt,
    endAt,
    selectedTypeCategory,
    selectedCards,
    selectedDateCategory,
    hasError,
    exportLink,
    activityList,
    hasNeverHadActivities: hasNeverHadActivities(state),
    hasActivities: hasActivities(state),
    isExportDisabled: isExportDisabled(state),
    showPreviousBalance: showPreviousBalance(state),
    showTransfersFooter: showTransfersFooter(state),
    startingBalance: startingBalance(state),
    goToStatements: ownArgs.goToStatements,
    goToActivityShow: ownArgs.goToActivityShow,
    typeCategories,
    cardCategories,
    showFilters: typeCategories.length > 0
  };
};
export const mapActionsToProps = () => ({
  emitTypeFilterChangedAction: updateSelectedTypeAction,
  emitCardFilterChangedAction: updateSelectedCardAction,
  onScrollToBottom: scrollAction,
  updateDateRange: (startAt, endAt) => {
    return updateDateRangeAction(startAt, endAt);
  },
  updateDateMenuSelection: selectedDateCategory => {
    return updateDateMenuSelectionAction(selectedDateCategory);
  }
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);